import { ReactNode, useRef } from 'react';

import { useGlobalHotkeys } from '@/hooks/shortcutHooks/useGlobalHotkeys.ts';

/**
 * Focusable root that bounds keyboard shortcut handling (`scopeRef` for `useGlobalHotkeys`).
 * Must stay inside `GlobalModalsProvider` so hotkey handlers can use `useGlobalModalsContext()`.
 */
export const GlobalHotkeysFocusShell = ({ children }: { children: ReactNode }) => {
  const focusShellRef = useRef<HTMLDivElement>(null);
  useGlobalHotkeys({ scopeRef: focusShellRef });

  return (
    <div ref={focusShellRef} tabIndex={-1}>
      {children}
    </div>
  );
};
